
import Vue from 'vue';
import { logout } from '../auth';

export default Vue.extend({
  name: 'LogoutButton',
  methods: {
    async handleLogout() {
      await logout();
      this.$router.push('/login');
    }
  }
});
